import { ReactElement, useMemo } from 'react'

import type { InvoiceCustomer } from '../../types/invoices/invoiceCustomer'
import type { MissingEInvoiceDetails } from '../../types/missingEInvoiceDetails'
import type { SendAsEInvoiceForm } from '../../types/sendAsEInvoiceForm'
import { getPredefinedCustomerValuesFromInvoiceCustomer } from '../../utils/eInvoices/getPredefinedCustomerValuesFromInvoiceCustomer'
import { SendAsEInvoiceModal } from '../SendAsEInvoiceModal'
import type { SendAsEInvoiceModalView } from '../SendAsEInvoiceModal/types/sendAsEInvoiceModalView'

interface SendInvoiceAsEInvoiceModalProps {
  customer?: InvoiceCustomer
  id: string
  missingEInvoiceDetails?: MissingEInvoiceDetails
  onSubmit: (formData: SendAsEInvoiceForm) => void
  view: Exclude<SendAsEInvoiceModalView, 'invoiceEditor'>
}

// Shared by ShareDocumentMenu (single document view) and InvoicesTableStaticActions (table quick actions).
export const SendInvoiceAsEInvoiceModal = ({
  customer,
  id,
  missingEInvoiceDetails,
  onSubmit,
  view,
}: SendInvoiceAsEInvoiceModalProps): ReactElement => {
  const predefinedCustomerValues = useMemo(() => getPredefinedCustomerValuesFromInvoiceCustomer(customer), [customer])
  const isMissingCustomerEInvoicingAddress = !!missingEInvoiceDetails?.customerDetails.isMissingCustomerEInvoiceAddress

  return (
    <SendAsEInvoiceModal
      attachmentsEnabled={false}
      id={id}
      isMissingCustomerEInvoicingAddress={isMissingCustomerEInvoicingAddress}
      isSubmitting={false}
      onSubmit={onSubmit}
      predefinedCustomerValues={predefinedCustomerValues}
      size="s"
      view={view}
    />
  )
}
